import styled from 'styled-components'
import ReactSelect from 'react-select'

export const PresetsContainer = styled.div`
    padding: 24px 8px 0px 16px;
    font-size: 13px;
    color: ${({ theme }) => theme['gray-800']};

    .sidebar-title {
        font-weight: 700;
        padding-bottom: 32px;
    }
`

export const FilterContainer = styled.div`
    margin-bottom: 16px;

    .filter-label {
        font-weight: 600;
        font-size: 13px;
    }

    .Select {
        margin-top: 4px;
        width: 220px;
    }
`

export const Select = styled(ReactSelect)`
    * {
        scrollbar-width: auto;
        scrollbar-color: var(--gray-400) var(--gray-0);
    }

    /* Chrome, Edge, and Safari */
    *::-webkit-scrollbar {
        width: 8px;
    }

    *::-webkit-scrollbar-track {
        background: var(--gray-0);
    }

    *::-webkit-scrollbar-thumb {
        background-color: var(--gray-400);
        border-radius: 4px;
        border: 1px solid var(--gray-0);
    }
`
